import { useContext, useEffect, useState } from "react";
import { Modal, Fade, Box, Backdrop, Typography, Grid, TextField, Button, Autocomplete, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { ActualizarDefectivo, CreateDefectivo } from "../../../hooks/defectivos";
import { ThemeContext } from "@emotion/react";
import swal from 'sweetalert2'
import { GetAllAlmacenes } from "../../../hooks/getAllAlmacenes";
import { GetAllAlmacenesList } from "../../../hooks/getListAlmacen";
import { set } from "react-hook-form";


export const ModalDefectivo = ({ open, isEdit, defectivoEdit, handleClose }) => {

  const style = {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    justifyContent: 'center'
  };

  const theme = useContext(ThemeContext)

  const { crearDefectivoMutation } = CreateDefectivo();
  const { getAllAlmacenesListMutation } = GetAllAlmacenesList();
  const { actualizarDefectivoMutation } = ActualizarDefectivo();
  const [almacenes, setAlmacenes] = useState([]);
  const [almSelect, setAlmSelect] = useState(null);
  const [errorName, setErrorName] = useState(false);
  const [errorCod, setErrorCod] = useState(false);
  const [errorDes, setErrorDes] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault()
    if (
      almSelect !== null &&
      event.target.def_codigo.value !== '' &&
      event.target.def_defecto.value !== ''
    ) {
      let data = {
        alma_id: almSelect?.id,
        def_codigo: event.target.def_codigo.value,
        def_defecto: event.target.def_defecto.value,
        def_status: isEdit ? (+event.target.def_status.value === 1 ? true : false) : true
      }
      if (isEdit) {
        actualizarDefectivoMutation({ id: defectivoEdit?.def_id, body: data }, {
          onSuccess: (data) => {
            if (data.success) {
              swal
                .fire({
                  position: "top-end",
                  icon: "success",
                  title: "Defectivo actualizado con exito",
                  showConfirmButton: false,
                  timer: 1500,
                })
            }
          },
          onError: (error) => {
            swal.fire({
              position: "top-end",
              icon: "error",
              title: "Fallo al actualizar defectivo",
              showConfirmButton: false,
              timer: 1500
            })
          },
          onSettled: () => {
            handleClose();
          }
        })
      } else {
        crearDefectivoMutation(data, {
          onSuccess: (data) => {
            if (data.success) {
              swal
                .fire({
                  position: "top-end",
                  icon: "success",
                  title: "Defectivo creado con exito",
                  showConfirmButton: false,
                  timer: 1500,
                })
            }
          },
          onError: (error) => {
            swal.fire({
              position: "top-end",
              icon: "error",
              title: "Fallo al crear defectivo",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(error)
          },
          onSettled: () => {
            handleClose();
          }
        })
      }

    } else {
      if (almSelect === null) setErrorName(true)
      if (event.target.def_codigo.value === '') setErrorCod(true)
      if (event.target.def_defecto.value === '') setErrorDes(true)
    }
  };

  const get_almacenes = () => {
    getAllAlmacenesListMutation({}, {
      onSuccess: (data) => {
        setAlmacenes(data);
        if (isEdit) setAlmSelect(data.find(item => item.id === defectivoEdit.alma_id));
      },
      onError: (error) => {
        console.log(error)
      }
    })
  }

  useEffect(() => {
    get_almacenes();
  }, []);


  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };



  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <form onSubmit={onSubmit}>
            <Grid container spacing={0}>
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1 }} className="center_item">
                <Typography id="transition-modal-title" variant="h6" component="h2">
                  {isEdit ? 'Editar Defectivo' : 'Nuevo Defectivo'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 0, mb: 1, pr: 1 }} >
                <Autocomplete
                  fullWidth
                  id="alma_id"
                  name="alma_id"
                  getOptionLabel={(opcion) => opcion?.label}
                  filterSelectedOptions
                  options={almacenes}
                  onKeyDown={handleKeyUp}
                  value={almSelect}
                  onChange={(e, newValue) => {
                    setAlmSelect(newValue);
                    newValue ? setErrorName(false) : setErrorName(true)
                  }}
                  renderOption={(props, option) => (
                    <Box {...props} key={option?.id}>{option.label}</Box>
                  )}
                  renderInput={(params) =>
                    <TextField {...params} label="Almacen" size="small" fullWidth required error={errorName} helperText={errorName ? 'Ingrese un valor' : ''} />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id="def_codigo"
                  label="Código"
                  name="def_codigo"
                  fullWidth
                  size="small"
                  sx={{ color: theme.palette.primary.input }}
                  defaultValue={isEdit ? defectivoEdit?.def_codigo : null}
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorCod(false) :
                      setErrorCod(true)
                  }}
                  error={errorCod}
                  helperText={errorCod ? 'Ingrese un valor' : ''}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1, mt: 2 }} >
                <TextField
                  id="def_defecto"
                  label="Defecto"
                  name="def_defecto"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  sx={{ color: theme.palette.primary.input }}
                  defaultValue={isEdit ? defectivoEdit?.def_defecto : null}
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorDes(false) :
                      setErrorDes(true)
                  }}
                  error={errorDes}
                  helperText={errorDes ? 'Ingrese un valor' : ''}
                />
              </Grid>
              {
                isEdit &&
                <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1, mt: 2 }} >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="def_status"
                      name="def_status"
                      defaultValue={defectivoEdit?.def_status ? 1 : 0}
                      label="Status"
                      size="small"
                    >
                      <MenuItem value={1}>Activo</MenuItem>
                      <MenuItem value={0}>Inactivo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              }
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1, mt: 2 }} >
                <Button variant="contained"
                  className="btn_system"
                  type="submit"
                >
                  {isEdit ? 'Editar Defectivo' : 'Crear Defectivo'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Fade>
    </Modal>
  )
}